import { useState, useEffect } from 'react'
import { useLanguage } from './../../../../utilities/LanguageContext'
import { LogErrors } from './../../../../utilities/LogErrors'

//Componentes personalizados del proyecto
//import { Concepts } from './../Concepts/Concepts'
import { Concepts } from './Concepts/Concepts'
import { Quizzes } from './Quizzes/Quizzes'
import { Videos } from './Videos/Videos'
import { Challenges } from './Challenges/Challenges'

//Componentes comunes generales
import { GoToTop } from './../../../Common/GoToTop'
import { GoToBack } from './../../../Common/GoToBack'

//Funciones personalizadas
import { UpdateQuickAccessOfCourse } from './../../../../utilities/BL/Student/Instruments'
import { EnableAllRestrictions, DisableAllRestrictions } from './../../../../utilities/BL/Security'
import { Disabled } from './../../Common/Disabled'
import { Credits } from './../../../Common/Credits/Credits'


const Teaching = ({ session, setSession, instrument, changeLearningInstrumentContent, topicName, isInstrumentEnabled, instrumentData = null }) => {
    const { translate } = useLanguage() // Obtén la función de traducción desde el contexto

    const [activeComponent, setActiveComponent] = useState('Concept') // Estado para controlar el componente activo
    const [currentTopicIndex, setCurrentTopicIndex] = useState(0) // Índice del tema actual
    const [topics, setTopics] = useState([]) // Lista de temas filtrados

    const [isConceptEnabled, setIsConceptEnabled] = useState(null)
    const [isQuizzEnabled, setIsQuizzEnabled] = useState(null)
    const [isVideoEnabled, setIsVideoEnabled] = useState(null)
    const [isChallengeEnabled, setIsChallengeEnabled] = useState(null)


    useEffect(() => {
        if (isInstrumentEnabled === true) {
            let availableTopics = null
            
            const backToResultsView = session?.navigation?.backToResultsView
            
            if (backToResultsView) {
                // Obtener el listado de preguntas contestadas incorrectamente
                const badAnsweredQuestions = session?.badAnsweredQuestions
                
                if (badAnsweredQuestions) {
                    if (badAnsweredQuestions.length > 0) {
                        availableTopics = badAnsweredQuestions
                        setTopics(badAnsweredQuestions)
                    }
                }
            } else {    
                // Extraer todos los temas disponibles con type: 2
                availableTopics = session.courses.blocks.flatMap(block =>
                    block.items.filter(item => item.type === 2)
                )
                
                setTopics(availableTopics)

                // const blocks = session?.courses?.blocks
                // if (blocks) {
                //     availableTopics = session.courses.blocks.flatMap(block =>
                //         block.items.filter(item => item.type === 2)
                //     )
                    
                //     setTopics(availableTopics)
                // }
            }
            
            if (availableTopics) {
                // Encontrar la posición del tema actual
                const currentIndex = availableTopics.findIndex(item => item.id === session.navigation.instrument.id)
                setCurrentTopicIndex(currentIndex)
            }

            if (instrument) {
                if (instrument.concept === null) {
                    setIsConceptEnabled(false)
                } else {
                    setIsConceptEnabled(true)
                }

                if (instrument.quizz === null) {
                    setIsQuizzEnabled(false)
                } else {
                    setIsQuizzEnabled(true)
                }
                
                if (instrument.video === null) {
                    setIsVideoEnabled(false)
                } else {
                    setIsVideoEnabled(true)
                }

                if (instrument.challenge === null) {
                    setIsChallengeEnabled(false)
                } else {
                    setIsChallengeEnabled(true)
                }
            }
        }
    }, [session])

    const GoToPreviousTopic = async () => {
        try {
            if (currentTopicIndex > 0) {
                const previousTopic = topics[currentTopicIndex - 1]
                await UpdateSessionAndNavigate(previousTopic)
            }
        } catch (error) {
            await LogErrors('GoToPreviousTopic - Teaching', error)
        }
    }
    
    const GoToNextTopic = async () => {
        try {
            if (currentTopicIndex < topics.length - 1) {
                const nextTopic = topics[currentTopicIndex + 1]
                await UpdateSessionAndNavigate(nextTopic)
            }
        } catch (error) {
            await LogErrors('GoToNextTopic - Teaching', error)
        }
    }

    const UpdateSessionAndNavigate = async (newTopic) => {
        try {
            const backToResultsView = session?.navigation?.backToResultsView

            if (backToResultsView) {                
                // Actualizar info de navegación
                session.navigation.instrument.id = newTopic.id
                session.navigation.instrument.name = newTopic.name
                session.navigation.instrument.type = newTopic.type
                session.navigation.instrument.enabled = newTopic.enabled
                
                const updatedSession = { ...session } // Clonar el objeto para forzar re-render
                setSession(updatedSession)
                
                await changeLearningInstrumentContent(updatedSession)
            } else {
                // Actualizar el estado de navegación en la sesión
                const response = await UpdateQuickAccessOfCourse(session, newTopic) //newTopic.id
                
                if (response.success) {
                    const updatedSession = { ...response.data } // Clonar el objeto para forzar re-render
                    setSession(updatedSession)
                    await changeLearningInstrumentContent(updatedSession)
                } else {
                    console.log('Error al actualizar la sesión')
                }
            }
        } catch (error) {
            await LogErrors('UpdateSessionAndNavigate - Teaching', error)
        }
    }

    const LoadPage = async () => {
        try {
            document.body.classList.add('BodyComplete')
        } catch (error) {
            
        }
    }

    useEffect(() => {
        EnableAllRestrictions()
        LoadPage()
        
        return () => {
            DisableAllRestrictions()
        }
    }, [])


    return (
        isInstrumentEnabled === true ? (
            <>
                <main className='Container-FullHeight Teaching'>
                    <div className="container">
                        {session?.navigation?.backToResultsView ? (
                            <GoToBack url={'/results/items'} />
                        ) : (
                            <GoToBack url={'/course'} />
                        )}
                    </div>
                    
                    <div className='Teaching-Container'>
                        {activeComponent === 'Concept' && <Concepts topicName={topicName} instrument={instrument} instrumentData={instrumentData} />}
                        {activeComponent === 'Quiz' && <Quizzes instrument={instrument} instrumentData={instrumentData} />}
                        {(session?.navigation?.course?.id != 670 && session?.navigation?.course?.id != 671) && (
                            activeComponent === 'Video' && <Videos session={session} setSession={setSession} instrument={instrument} instrumentData={instrumentData} />
                        )}
                        {/* {(session?.navigation?.center?.id != 2 && session?.navigation?.center?.id != 228) && ( */}
                        {session?.navigation?.center?.id != 228 && ( // Es diferente a este centro o centros
                            (session?.navigation?.course?.id != 670 && session?.navigation?.course?.id != 671) && ( // Es diferente a estos grupos de Ciudadanía Digital
                                activeComponent === 'Challenge' && <Challenges instrument={instrument} instrumentData={instrumentData} />
                            )
                        )}
                    </div>
                </main>

                <aside className='Teaching-Menu'>
                    <div className='Teaching-Menu-Container'>
                        {/* Botón Previous (solo si hay un tema anterior) */}
                        {currentTopicIndex === 0 ? (
                            <div className='Teaching-Menu-Button-Disabled'>
                                <i className='bi bi-arrow-left Teaching-Menu-Button-Icon'></i>
                                <span className='Teaching-Menu-Button-Disabled-Text'>{translate('labels.viewer.teaching.previous')}</span>
                            </div>
                        ) : (
                            <button type='button' className='Teaching-Menu-Button' onClick={GoToPreviousTopic}>
                                <i className='bi bi-arrow-left Teaching-Menu-Button-Icon'></i>
                                <span className='Teaching-Menu-Button-Text'>{translate('labels.viewer.teaching.previous')}</span>
                            </button>
                        )}

                        {(isConceptEnabled && isConceptEnabled === true) && (
                            <button type='button' className={`Teaching-Menu-Button ${activeComponent === 'Concept' ? 'Teaching-Menu-Bottom-Active' : ''}`} onClick={() => setActiveComponent('Concept')}>
                                <i className='bi bi-file-earmark-text Teaching-Menu-Button-Icon'></i><span className='Teaching-Menu-Button-Text'> {translate('labels.viewer.teaching.concept')}</span>
                            </button>
                        )}
                        {(isQuizzEnabled && isQuizzEnabled === true) && (
                            <button type='button' className={`Teaching-Menu-Button ${activeComponent === 'Quiz' ? 'Teaching-Menu-Bottom-Active' : ''}`} onClick={() => setActiveComponent('Quiz')}>
                                <i className='bi bi-ui-radios Teaching-Menu-Button-Icon'></i><span className='Teaching-Menu-Button-Text'> {translate('labels.viewer.teaching.quizz')}</span>
                            </button>
                        )}
                        {(isVideoEnabled && isVideoEnabled === true) && (
                            <button type='button' className={`Teaching-Menu-Button ${activeComponent === 'Video' ? 'Teaching-Menu-Bottom-Active' : ''}`} onClick={() => setActiveComponent('Video')}>
                                <i className='bi bi-play-btn Teaching-Menu-Button-Icon'></i><span className='Teaching-Menu-Button-Text'> {translate('labels.viewer.teaching.video')}</span>
                            </button>
                        )}
                        {(isChallengeEnabled && isChallengeEnabled === true) && (
                            <>
                                {/* {(session?.navigation?.center?.id != 2 && session?.navigation?.center?.id != 228) && ( */}
                                {session?.navigation?.center?.id != 228 && (
                                    <button type='button' className={`Teaching-Menu-Button ${activeComponent === 'Challenge' ? 'Teaching-Menu-Bottom-Active' : ''}`} onClick={() => setActiveComponent('Challenge')}>
                                        <i className='bi bi-layout-split Teaching-Menu-Button-Icon'></i><span className='Teaching-Menu-Button-Text'> {translate('labels.viewer.teaching.challenge')}</span>
                                    </button>
                                )}
                            </>
                        )}

                        {/* Botón Next (solo si hay un tema siguiente) */}
                        {currentTopicIndex < topics.length - 1 ? (
                            <button type='button' className='Teaching-Menu-Button' onClick={GoToNextTopic}>
                                <span className='Teaching-Menu-Button-Text'>{translate('labels.viewer.teaching.next')}</span>
                                <i className='bi bi-arrow-right Teaching-Menu-Button-Icon'></i>
                            </button>
                        ) : (
                            <div className='Teaching-Menu-Button-Disabled Teaching-Menu-Button-Disabled--Bottom'>
                                <span className='Teaching-Menu-Button-Disabled-Text'>{translate('labels.viewer.teaching.next')}</span>
                                <i className='bi bi-arrow-right Teaching-Menu-Button-Icon'></i>
                            </div>
                        )}
                    </div>
                </aside>

                <GoToTop />
            </>
        ) : (
            <main className='Container-FullHeight Teaching'>
                <div className="container">
                    {session?.navigation?.backToResultsView ? (
                        <GoToBack url={'/results/items'} />
                    ) : (
                        <GoToBack url={'/course'} />
                    )}
                </div>
                
                <div className='Teaching-Container'>
                    <div className='container Concepts'>
                        <p className='Concepts__Title'>{topicName}</p>
                    
                        <Disabled />
                    </div>
                </div>
            </main>
        )
    )
}

export { Teaching };